import { MapContainer, Polygon, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const M_PER_DEG = 111320;

// Rettangolo del pannello ruotato secondo orientamento e azimut della falda (come negli esempi Google Solar)
function panelPolygon([lat, lng, orient, azimuth], w, h) {
  const hw = w / 2;
  const hh = h / 2;
  const rot = (orient === "L" ? 90 : 0) + azimuth;
  return [[hw, hh], [hw, -hh], [-hw, -hh], [-hw, hh]].map(([x, y]) => {
    const dist = Math.hypot(x, y);
    const heading = ((Math.atan2(y, x) * 180) / Math.PI + rot) * (Math.PI / 180);
    const north = dist * Math.cos(heading);
    const east = dist * Math.sin(heading);
    return [lat + north / M_PER_DEG, lng + east / (M_PER_DEG * Math.cos((lat * Math.PI) / 180))];
  });
}

// Raggruppa i pannelli: riempie prima la falda migliore, poi la successiva; dentro ogni falda
// parte dal pannello più produttivo e aggiunge i più vicini, così il campo resta compatto
function groupPanels(panels, count) {
  const bySeg = new Map();
  panels.forEach((p) => {
    const seg = p[4] ?? 0;
    if (!bySeg.has(seg)) bySeg.set(seg, []);
    bySeg.get(seg).push(p);
  });
  const out = [];
  for (const group of bySeg.values()) {
    const [first] = group;
    const sorted = [...group].sort((a, b) => Math.hypot(a[0] - first[0], a[1] - first[1]) - Math.hypot(b[0] - first[0], b[1] - first[1]));
    for (const p of sorted) {
      if (out.length >= count) return out;
      out.push(p);
    }
  }
  return out;
}

export const RoofMap = ({ roof, count }) => {
  const panels = groupPanels(roof.panels, count);
  return (
    <div data-testid="roof-map" className="relative z-0 mt-5 h-72 overflow-hidden border border-slate-800 sm:h-80">
      <MapContainer
        center={roof.center}
        bounds={roof.bbox || undefined}
        zoom={20}
        maxZoom={21}
        scrollWheelZoom={false}
        attributionControl
        className="h-full w-full"
      >
        <TileLayer
          url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          attribution="Immagini &copy; Esri"
          maxNativeZoom={19}
          maxZoom={21}
        />
        {panels.map((p, i) => (
          <Polygon key={`${p[0]}-${p[1]}`} positions={panelPolygon(p, roof.panel_w, roof.panel_h)}
            pathOptions={{ color: "#0B0F17", weight: 0.6, fillColor: "#F5B700", fillOpacity: 0.85 }} />
        ))}
      </MapContainer>
      <span data-testid="roof-map-count" className="absolute bottom-3 left-3 z-[400] bg-[#0B0F17]/85 px-3 py-1.5 text-xs font-medium text-white">
        {panels.length} pannelli posizionati sul tetto
      </span>
    </div>
  );
};
